import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Typography } from "@mui/material";
import ScientistImg3 from "../../assets/images/ScientistImg3.png";
import { ConsultancyForm } from "./ConsultancyForm";
import "../../assets/css/scientist.css";
import { convertImagePathToUrl } from "../../utils";

const formatModalDescription = (description) =>
  description?.replace(/(\r\n|\r|\n)/g, "<br>");

export const Consultancy = ({ consultancy }) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true, // Animation runs only once
      offset: 200, // Triggers the animation when 200px before the section is in view
    });
  }, []);

  if (consultancy.length === 0) return null;

  return (
    <div>
      <div className="portfolioImg6">
        <div
          className="flex justify-between h-full md:h-[700px] consultancy"
          data-aos="fade-right"
        >
          <div
            className="justify-end hidden lg:flex"
            style={{ flex: 1, background: "#EBEEF3" }}
          >
            <img
              src={convertImagePathToUrl(
                consultancy?.details[0]?.sub_headings[0]?.sub_heading_image
              )}
              alt="Team2"
              className="h-full mr-auto leftArrowStyle"
            />
          </div>
          <div
            className="flex flex-col items-center"
            style={{ flex: 3, background: "#EBEEF3" }}
          >
            <div
              className="sm:mt-28 lg:mx-0 py-8 mb-4"
              style={{ maxWidth: "580px" }}
            >
              <Typography
                className="text-4xl font-bold text-center md:text-left"
                style={{
                  fontFamily: "Montserrat",
                }}
              >
                {consultancy?.section_title}
              </Typography>
              <div className="lg:hidden flex justify-self-center my-4">
                <img
                  src={convertImagePathToUrl(
                    consultancy?.details[0]?.sub_headings[0]?.sub_heading_image
                  )}
                  className="h-96 ml-auto leftArrowStyle"
                  alt="Scientist Research"
                />
              </div>
              {consultancy?.details?.map((detail, index) => (
                <>
                  {detail?.singleArray?.map((det, ind) => (
                    <>
                      {det?.key === "sub-heading" && (
                        <Typography
                          key={"desc"}
                          className="mx-auto text-sm my-8 text-center md:text-left"
                          style={{
                            fontWeight: 500,
                            fontFamily: "Montserrat",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: formatModalDescription(
                              det?.sub_heading_desc
                            ), // Correctly using dangerouslySetInnerHTML here
                          }}
                        />
                      )}
                    </>
                  ))}
                </>
              ))}
            </div>
          </div>
          <div className="hidden pr-10 lg:block" style={{ flex: 1 }}>
            <img
              src={ScientistImg3}
              className="h-full mr-auto leftArrowStyle"
              alt=""
            />
          </div>
        </div>
        <div style={{ overflowX: "hidden" }}>
          <ConsultancyForm />
        </div>
      </div>
    </div>
  );
};
